// app/javascript/controllers/message_media_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["lightbox"]
  static values = {
    messageId: String
  }

  openLightbox(event) {
    event.preventDefault()
    const index = parseInt(event.currentTarget.dataset.mediaIndex || 0, 10)
    const messageId = this.messageIdValue

    // Find the viewer modal for this message
    const viewerId = `message-media-viewer-${messageId}`
    const viewer = document.getElementById(viewerId)

    if (!viewer) return

      // Dispatch the event to the image-viewer controller element
      viewer.dispatchEvent(new CustomEvent("open-image-viewer", {
      bubbles: false,
      detail: { index }
    }))
  }

  closeLightbox() {
    if (this.hasLightboxTarget) {
      this.lightboxTarget.classList.add("hidden")
    }
  }
}

